import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { handleDownloadFile } from '../../../utils/utils';
import { getDateDaysFromNow } from '../../fuctions';
import { getTrackingReport } from '../api';

const initialState = {
  startDate: getDateDaysFromNow(-60),
  endDate: getDateDaysFromNow(1),
  account: '',
};

export default function useTrackingReport(isAdmin: boolean) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [startDate, setStartDate] = useState<Date | null>(
    initialState.startDate,
  );
  const [endDate, setEndDate] = useState<Date | null>(initialState.endDate);
  const [account, setAccount] = useState<string>(initialState.account);

  const curPayload = {
    startDate,
    endDate,
    account,
  };

  const onChangeShippedDates = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const onChangeAccount = (accountNumber: string) => {
    setAccount(accountNumber);
  };

  const clearFilters = () => {
    setStartDate(initialState.startDate);
    setEndDate(initialState.endDate);
    setAccount(initialState.account);
  };

  const fetchTrackingReport = async (payload: any) => {
    const { report } = await getTrackingReport(payload, isAdmin, setIsLoading);

    if (report !== null && report.hasOwnProperty('file')) {
      handleDownloadFile(report.file, report.filename, true);
    } else {
      enqueueSnackbar('An error occured while downloading the report.', {
        variant: 'error',
      });
    }
  };

  const onClickDownload = () => {
    setIsLoading(true);
    fetchTrackingReport(curPayload);
  };

  return {
    isLoading,
    startDate,
    endDate,
    onChangeShippedDates,
    account,
    onChangeAccount,
    clearFilters,
    onClickDownload,
  };
}
